
import { Component, Vue, Emit } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import { unbindEmail } from '@/apis/myInfo/myInfo'
import { Dialog } from 'vant'
import i18n from '@/lang';
@Component({})
export default class NoBindEmail extends Vue {
  // private bindRouter: any = ''
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  //调用父组件方法
  @Emit('showLast')
  showLast() {} //ktp0215926778
  //解除绑定
  Unbind() {
    Dialog.confirm({
      title: '',
      message: i18n.t('ktpMy.确认解绑当前已绑定的邮箱吗？') as string,
      getContainer: '.noBindEmail',
    })
      .then(() => {
        unbindEmail()
          .then((res) => {
            this.$store.dispatch('setUserInfo')
          })
          .catch((err) => {})
      })
      .catch(() => {})
  }
  // mounted(){
  //   this.bindRouter = this.$route.query.bind
  // }
  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.邮箱') as string,
      showTitle: true,
      backConfig: () => {
        this.$router.push('/myAllSetting?detail=myAccountManage')
      },
    })
  }
}
